import { Link } from "react-router-dom";

export function SciNotFound() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-start justify-center px-6" data-testid="sci-not-found">
      <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">404</p>
      <h1 className="mt-2 font-editorial text-4xl text-stone-900">Page not found</h1>
      <Link to="/" data-testid="sci-not-found-home" className="mt-6 text-sm font-medium text-[#002147] underline underline-offset-2">Back to home</Link>
    </div>
  );
}

export function SciLoadError({ onRetry }) {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-start justify-center px-6" data-testid="sci-load-error">
      <h1 className="font-editorial text-3xl text-stone-900">This page couldn't load</h1>
      <p className="mt-2 text-sm text-stone-600">Something went wrong on our side. Please try again.</p>
      <button type="button" onClick={onRetry} data-testid="sci-load-error-retry" className="mt-6 inline-flex min-h-[44px] items-center rounded-full bg-[#002147] px-5 text-sm font-medium text-white hover:bg-[#0b3366]">Try again</button>
    </div>
  );
}
